import React, { useEffect, useState } from 'react';
import * as Icons from 'react-feather';
import DataTable from 'react-data-table-component';
import { Link } from 'react-router-dom';
import { ReactComponent as SortArrow } from '../../shared/img/chevron-up-down.svg';

function VehicleEnquiryGrid({ data, onEdit, onDelete, onAction }) {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    setRows(Array.isArray(data) ? data : []);
  }, [data]);

  const columns = [
    {
      name: <div className="titlename"><span>Vehicle</span></div>,
      selector: (row) => row.Vehicle || row.VehicleLabel || row.VehicleNameValue || row.VehicleName,
      cell: (row) => {
        const label = row.Vehicle || row.VehicleLabel || row.VehicleNameValue || row.VehicleName || '';
        return <span title={label}>{label}</span>;
      },
      sortable: true,
      sortIcon: <span><SortArrow /></span>
    },
    {
      name: <div className="titlename"><span>Vehicle Cost</span></div>,
      selector: (row) => row.VehicleCost,
      cell: (row) => <span title={row.VehicleCost}>{row.VehicleCost}</span>,
      sortable: true,
      sortIcon: <span><SortArrow /></span>
    },
    {
      name: <div className="titlename"><span>Payment Type</span></div>,
      selector: (row) => row.PaymentType,
      cell: (row) => <span title={row.PaymentType}>{row.PaymentType}</span>,
      sortable: true,
      sortIcon: <span><SortArrow /></span>
    },
    {
      name: <div className="titlename"><span>Down Payment</span></div>,
      selector: (row) => row.DownPayment,
      cell: (row) => <span title={row.DownPayment}>{row.DownPayment}</span>,
      sortable: true,
      sortIcon: <span><SortArrow /></span>
    },
    {
      name: <div className="titlename"><span>EMI Tenure</span></div>,
      selector: (row) => row.EMITenure,
      cell: (row) => <span title={row.EMITenure}>{row.EMITenure}</span>,
      sortable: true,
      sortIcon: <span><SortArrow /></span>
    },
    {
      name: <div className="titlename"><span>EMI Amount</span></div>,
      selector: (row) => row.EMIAmount,
      cell: (row) => <span title={row.EMIAmount}>{row.EMIAmount}</span>,
      sortable: true,
      sortIcon: <span><SortArrow /></span>
    },
    {
      name: <div className="titlename"><span>Processing Fees</span></div>,
      selector: (row) => row.ProcessingFees,
      cell: (row) => <span title={row.ProcessingFees}>{row.ProcessingFees}</span>,
      sortable: true,
      sortIcon: <span><SortArrow /></span>
    },
  ];

  if (onAction === "Edit" || onAction === "Add" ) {
    columns.push({
        name: <div className="titlename">Actions</div>,
        cell: (row) => (
          <div className="edit-delete-action">
            <Link
              className="me-2 p-2"
              to=""
              onClick={(e) => {
                e.preventDefault();
                if (onEdit) {
                  onEdit(row);
                }
              }}
            >
              <Icons.Edit data-feather="edit" className="feather-edit" />
            </Link>
            <Link
              className="confirm-text p-2"
              to=""
              onClick={(e) => {
                e.preventDefault();
                if (onDelete) {
                  onDelete(row);
                }
              }}
            >
              <Icons.Trash2 data-feather="trash-2" className="feather-trash-2" />
            </Link>
          </div>
        ),
        center: 'true',
        width: '190px'
      });
  }
  

  return (
    <div className="card table-list-card">
      <div className="card-body">
        <DataTable
          className="table-responsive product-list"
          columns={columns}
          data={rows}
          sortIcon={<SortArrow />}
          persistTableHead
        />
      </div>
    </div>
  );
}

export default VehicleEnquiryGrid;
